import React, { useState } from 'react';
import axios from 'axios';
import { baseurl } from '../../config/url';

const PowerPackVisibility = ({ refreshProductBoxes }) => {
  // Define state variables for the form inputs
  const [productName, setProductName] = useState('');
  const [productPrice, setProductPrice] = useState('');
  const [productDescription ,setProductDescription] =useState('');
  const [productSize, setProductSize] =useState('');
  const [productStock ,setProductStock] =useState('');
  const [productminquantity ,setProductminquantity] =useState('');
  const [productmaxquantity , setProductmaxquantity] =useState('');
  const [productsaleMode ,setProductsaleMode] =useState('');
  const [productselectedCategory ,setProductselectedCategory] =useState('');
  const [productselectedSubcategory ,setProductselectedSubcategory] =useState('');
  const [productImage, setProductImage] = useState(null);
  const [productBox, setProductBox] = useState('box1'); // Default to Box 1

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('name', productName);
    formData.append('price', productPrice);
    formData.append('description' ,productDescription);
    formData.append('size' ,productSize);
    formData.append('stock',productStock);
    formData.append('minquantity',productminquantity)
    formData.append('maxquantity' , productmaxquantity);
    formData.append('saleModee',productsaleMode);
    formData.append('selectedCategory' ,productselectedCategory);
    formData.append('selectedSubcategory' ,productselectedSubcategory);
    formData.append('image', productImage);
    formData.append('box', productBox);

    try {
      await axios.post(`${baseurl}/api/seller/products/add`, formData);
      alert('Product added successfully');
      setProductName('');
      setProductPrice('');
      setProductDescription('');
      setProductSize('');
      setProductStock('');
      setProductminquantity('');
      setProductmaxquantity('');
      setProductsaleMode('');
      setProductselectedCategory('');
      setProductselectedSubcategory('');
      setProductImage(null);
      setProductBox('box1'); // Reset to default box

      // Trigger refresh of product boxes
      if (refreshProductBoxes) refreshProductBoxes();
    } catch (error) {
      console.error('Error adding product:', error);
      alert('Failed to add product');
    }
  };

  return (
    <div className="bg-gray-100 p-6">
      <h1 className="text-3xl font-bold text-center mb-6">Add Product to Box</h1>
      <form
        onSubmit={handleSubmit}
        className="bg-white shadow-md rounded-lg p-6 max-w-lg mx-auto"
      >
        <div className="mb-4">
          <label
            htmlFor="productName"
            className="block text-sm font-medium text-gray-700"
          >
            Product Name
          </label>
          <input
            type="text"
            id="productName"
            value={productName}
            onChange={(e) => setProductName(e.target.value)}
            className="mt-1 p-2 border border-gray-300 rounded-lg w-full"
            required
          />
        </div>

        <div className="mb-4">
          <label
            htmlFor="productPrice"
            className="block text-sm font-medium text-gray-700"
          >
            Product Price
          </label>
          <input
            type="number"
            id="productPrice"
            value={productPrice}
            onChange={(e) => setProductPrice(e.target.value)}
            className="mt-1 p-2 border border-gray-300 rounded-lg w-full"
            required
          />
        </div>

        <div className="mb-4">
          <label
            htmlFor="productDescription"
            className="block text-sm font-medium text-gray-700"
          >
            Product Description
          </label>
          <input
            type="text"
            id="productDescription"
            value={productDescription}
            onChange={(e) => setProductDescription(e.target.value)}
            className="mt-1 p-2 border border-gray-300 rounded-lg w-full"
            required
          />
        </div>

        <div className="mb-4">
          <label
            htmlFor="productStock"
            className="block text-sm font-medium text-gray-700"
          >
            Product Stock
          </label>
          <input
            type="text"
            id="productStock"
            value={productStock}
            onChange={(e) => setProductStock(e.target.value)}
            className="mt-1 p-2 border border-gray-300 rounded-lg w-full"
            required
          />
        </div>

        <div className="mb-4">
          <label
            htmlFor="productminquantity"
            className="block text-sm font-medium text-gray-700"
          >
            Product Minquantity
          </label>
          <input
            type="text"
            id="productminquantity"
            value={productminquantity}
            onChange={(e) => setProductminquantity(e.target.value)}
            className="mt-1 p-2 border border-gray-300 rounded-lg w-full"
            required
          />
        </div>

        <div className="mb-4">
          <label
            htmlFor="productmaxquantity"
            className="block text-sm font-medium text-gray-700"
          >
            Product Maxquantity
          </label>
          <input
            type="text"
            id="productmaxquantity"
            value={productmaxquantity}
            onChange={(e) => setProductmaxquantity(e.target.value)}
            className="mt-1 p-2 border border-gray-300 rounded-lg w-full"
            required
          />
        </div>

        <div className="mb-4">
          <label
            htmlFor="productmaxquantity"
            className="block text-sm font-medium text-gray-700"
          >
            Product Maxquantity
          </label>
          <input
            type="text"
            id="productmaxquantity"
            value={productmaxquantity}
            onChange={(e) => setProductmaxquantity(e.target.value)}
            className="mt-1 p-2 border border-gray-300 rounded-lg w-full"
            required
          />
        </div>

        <div className="mb-4">
          <label
            htmlFor="productImage"
            className="block text-sm font-medium text-gray-700"
          >
            Product Image
          </label>
          <input
            type="file"
            id="productImage"
            onChange={(e) => setProductImage(e.target.files[0])}
            className="mt-1 p-2 border border-gray-300 rounded-lg w-full"
            required
          />
        </div>
        <div className="mb-4">
          <label
            htmlFor="productBox"
            className="block text-sm font-medium text-gray-700"
          >
            Select Box
          </label>
          <select
            id="productBox"
            value={productBox}
            onChange={(e) => setProductBox(e.target.value)}
            className="mt-1 p-2 border border-gray-300 rounded-lg w-full"
          >
            <option value="box1">Box 1</option>
            <option value="box2">Box 2</option>
          </select>
        </div>
        <button
          type="submit"
          className="bg-blue-600 text-white py-2 px-4 rounded-lg w-full hover:bg-blue-700 transition"
        >
          Add Product
        </button>
      </form>
    </div>
  );
};

export default PowerPackVisibility;
